import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const EmptyListIcon = createIcon({
    viewBox: '0 0 120 120',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M88.729 38.7504V97.9287C88.729 98.5211 88.1595 99 87.4589 99H33.3092C32.0333 99 31 98.1272 31 97.05V22.95C31 21.8738 32.0333 21 33.3092 21H73.6157L88.729 38.7504Z'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <Path d='M73.8339 21.1836V38.854H88.9999' stroke='currentColor' strokeWidth='2' />
        </>
    ),
})

EmptyListIcon.displayName = 'EmptyListIcon'
